import React from 'react';
import { blueDark01 } from '../../../styles/colors';
import { Text, CloseIcon } from '../../../styles/common.styles';
import ModalFooter from '../modalFooter/ModalFooter';
import ModalTitle from '../modalTitle/ModalTitle';
import { ConfirmModalContent, ConfirmModalWrapper } from './ConfirmSubscriptionAdminModal.styles';

interface Props {
    isOpen: boolean;
    closeModal: () => void;
    onConfirm: () => void | Promise<void | boolean>;
    newAdminName: string;
}

const ConfirmSubscriptionAdminModal: React.FC<Props> = ({
    isOpen,
    closeModal,
    onConfirm,
    newAdminName,
}) => {
    const handleConfirm = async () => {
        const result = await onConfirm();
        // Only close modal if result is not false (for failed operations that want to keep modal open)
        // If result is undefined or true, close the modal
        if (result !== false) {
            closeModal();
        }
    };

    return (
        <ConfirmModalWrapper
            open={isOpen}
            onCancel={closeModal}
            centered
            footer={null}
            className="confirm-modal-container"
            closeIcon={<CloseIcon />}
        >
            <ModalTitle title="Confirm Subscription Admin change" icon="ic-modal-title-change-role.svg" />
            <ConfirmModalContent>
                <Text weight={400} height={18} size={14} color={blueDark01}>
                    Are you sure you want to make <span style={{ fontFamily: "Proxima N W15 Bold"}}>{newAdminName}</span> the Subscription
                    Admin?
                </Text>
            </ConfirmModalContent>
            <ModalFooter
                submit={handleConfirm}
                action="Save change"
                cancel={closeModal}
                cancelText="Cancel"
                cancelButtonWidth={100}
                actionButtonWidth={120}
            />
        </ConfirmModalWrapper>
    );
};

export default ConfirmSubscriptionAdminModal;
